// This file was auto-generated by querybuilder/Apollo and should not be edited.

import * as ExtendedFormFieldErrors from './ExtendedFormFieldErrors';
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { LetterRequestInput, LetterRequestMailChoice } from "./globalTypes";

// ====================================================
// GraphQL mutation operation: LetterRequestMutation
// ====================================================

export interface LetterRequestMutation_output_errors_extendedMessages {
  /**
   * A human-readable validation error.
   */
  message: string;
  /**
   * A machine-readable representation of the error.
   */
  code: string | null;
}

export interface LetterRequestMutation_output_errors {
  /**
   * The camel-cased name of the input field, or '__all__' for non-field errors.
   */
  field: string;
  /**
   * A list of validation errors with extended metadata.
   */
  extendedMessages: LetterRequestMutation_output_errors_extendedMessages[];
}

export interface LetterRequestMutation_output_session_letterRequest {
  /**
   * How the letter of complaint will be mailed.
   */
  mailChoice: LetterRequestMailChoice;
  /**
   * The tracking number for the letter. Note that when this is changed, the user
   * will be notified via SMS and added to a LOC follow-up campaign, if one has
   * been configured.
   */
  trackingNumber: string;
  /**
   * When the letter was mailed through the postal service.
   */
  letterSentAt: GraphQLDateTime | null;
  updatedAt: GraphQLDateTime;
}

export interface LetterRequestMutation_output_session {
  letterRequest: LetterRequestMutation_output_session_letterRequest | null;
}

export interface LetterRequestMutation_output {
  /**
   * A list of validation errors in the form, if any. If the form was valid, this list will be empty.
   */
  errors: LetterRequestMutation_output_errors[];
  session: LetterRequestMutation_output_session | null;
}

export interface LetterRequestMutation {
  output: LetterRequestMutation_output;
}

export interface LetterRequestMutationVariables {
  input: LetterRequestInput;
}

export const BlankLetterRequestInput: LetterRequestInput = {
  "mailChoice": ""
};

export const LetterRequestMutation = {
  // The following query was taken from LetterRequestMutation.graphql.
  graphQL: `# This file was auto-generated by querybuilder, please do not edit it.
mutation LetterRequestMutation($input: LetterRequestInput!) {
  output: letterRequest(input: $input) {
    errors { ...ExtendedFormFieldErrors },
    session {
      letterRequest {
        mailChoice,
        trackingNumber,
        letterSentAt,
        updatedAt
      }
    }
  }
}
${ExtendedFormFieldErrors.graphQL}`,
  name: "LetterRequestMutation",
  fetch(fetchGraphQL: (query: string, args?: any) => Promise<any>, args: LetterRequestMutationVariables): Promise<LetterRequestMutation> {
    return fetchGraphQL(LetterRequestMutation.graphQL, args);
  },
  blankInput: BlankLetterRequestInput,
};

export const fetchLetterRequestMutation = LetterRequestMutation.fetch;